import classNames from 'classnames'

import style from './style.scss'

type Props = {
  dark?: boolean
  gray?: boolean
  small?: boolean
}

function Loader({ dark, gray, small }: Props) {
  return (
    <div
      className={classNames(style.wrapper, {
        [style.dark]: dark,
        [style.gray]: gray,
        [style.small]: small,
      })}
      data-testid='loader'
    />
  )
}

export default Loader
